import contactUsBanner from "./contactUsBanner.jpg";

// Subscription images
import AdobeAcrobat from "./adobeAcrobate.png";
import AdobeSuite from "./adobeSuite.png";
import AmazonPrime from "./amazonPrime.png";
import asana from "./asana.png";
import CanvasPro from "./canvasPro.png";
import Crunchyroll from "./Crunchyroll.png";
import DisneyHotstar from "./disneyHotstar.png";
import figma from "./figma.png";
import Ganna from "./ganna.png";
import googleWorkspace from "./googleWorkspace.png";
import HBOMax from "./HBOMax.png";
import Hubspot from "./hubspot.png";
import JioCinema from "./jioCinema.png";
import jira from "./jira.png";
import LinkedinPremium from "./LinedinPremium.jpg";
import Microsoft365 from "./microsoft365.png";
import Netflix from "./netflix.png";
import notion from "./notion.png";
import OSNPlus from "./OSNPlus.png";
import Paramount from "./paramountPlus.png";
import shahid from "./shahid.jpg";
import SonyLiv from "./sonyLiv.png";
import Spotify from "./spotify.png";
import TinderPlus from "./tinderPlus.png";
import upwork from "./upwork.png";
import YoutubePremium from "./youtubePremium.png";
import zee5 from "./zee5.png";

import loyalityPointsCard from "./loyalityPointsCard.png";

// Travel suite
import TravelBanner from "./TravelBanner.jpg";

// traveller icons
import ManIcon from './man.png';
import ChildrenIcon from './children.png';
import InfantIcon from './toddler.png';
import HotelCityPalace from "./hotelCityPlace.png";

// hotel location placeholder image
import LocationMapPlaceholder from "./mapEntryHover.png";
import hotelPlaceHolderImage from "./hotelPlaceHolderImage.png";
import roomPlaceHolderImage from "./roomPlaceHolderImage.png";

// precious metals icons
import MMTCPAMPLogo from './mmtcPampLogo.png';

// reward coin icon
import rewardCoin from './rewardCoin.png';

// adneto white logo
import AdentoWhiteLogo from './AdnetoWhiteLogo.png';

export { 
  AdobeAcrobat, AdobeSuite, AmazonPrime, asana, CanvasPro, contactUsBanner, Crunchyroll, DisneyHotstar, figma, Ganna, 
  googleWorkspace, HBOMax, Hubspot, JioCinema, jira, LinkedinPremium, loyalityPointsCard, Microsoft365, Netflix, notion, OSNPlus, 
  Paramount, shahid, SonyLiv, Spotify, TinderPlus, TravelBanner, upwork, YoutubePremium, zee5, ManIcon, ChildrenIcon, InfantIcon, 
  HotelCityPalace, LocationMapPlaceholder, hotelPlaceHolderImage, roomPlaceHolderImage, MMTCPAMPLogo, rewardCoin, AdentoWhiteLogo
};
